import { render, staticRenderFns } from "./AllTables.vue?vue&type=template&id=3bc78651&"
import script from "./AllTables.vue?vue&type=script&lang=js&"
export * from "./AllTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports